/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для для блока менеджера в кабинете
   */
  app.CabinetManagerView = app.View.extend({
    el: '.your-manager',

    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#manager-template');
      this.gradeTemplate = app.helpers.TemplateHelper.getTemplate('#manager-grade-template');
      this.managerId = this.user.get('manager_id');
      this.model = new app.Manager();
      this.listenTo(this.settlement, 'change', this.fetchUser);
      this.listenTo(this.user, 'change:manager_id', this.onChangeManagerId);
      this.initChildViews();
    },

    initChildViews: function () {
      var self = this;
      this.childViews.managerContactsPopupViews = [];
      $('.contacts-js-popup-opener').each(function () {
        self.childViews.managerContactsPopupViews.push(new app.ManagerContactsPopupView({
          el: $(this),
        }));
      });
      this.childViews.messageToDirectorFormView = new app.MessageToDirectorFormView();
      this.childViews.messageToManagerFormView = new app.MessageToManagerFormView();
      this.childViews.messageToCallMeFormContactGroupView = new app.MessageToCallMeFormContactGroupView({
        checkAgreement: true,
      });
    },

    render: function (managerModel) {
      if (managerModel instanceof app.Manager) {
        this.$('#manager_block').html(this.template({
          manager: managerModel,
          settlement: this.settlement,
        }));
        this.$('#manager_grade').html(this.gradeTemplate({
          manager: managerModel,
        }));
      }
    },

    /**
     * Выполняет fetch модели пользователя
     */
    fetchUser: function () {
      this.user.fetch({
        data: {
          timestamp: Date.now(),
        },
      });
    },

    /**
     * Перерисовывает элемент при обновлении модели пользователя
     */
    onChangeManagerId: function () {
      var userManagerId = this.user.get('manager_id');
      if (this.managerId && userManagerId && this.managerId !== userManagerId) {
        this.managerId = userManagerId;
        this.model.fetch({
          url: app.entryScriptName + '/api/v3/manager/' + this.managerId + '/?expand=spec',
          success: this.render.bind(this),
        });
      }
    },
  });
})(jQuery);

}.call(window));